import { TFormattedMoney } from "@sembark-travel/money"
import {
	TTravelActivity,
	TTravelActivityTicketTouristConfiguration,
	TTravelActivityTicketType,
} from "../TravelActivities"
import { ISupplier, TSupplierContact } from "../Supplier"
import { IUser } from "../Auth"
import { ITrip } from "../Trips"
import { IPaymentable } from "../Payments"
import { TTourist, TTouristGroup, TTouristMember } from "../Tourists"
import { TTransportServiceLocationPoint } from "../TransportServices"

export type TTravelActivityBookingTicketTouristConfiguration = {
	id: number
	configuration: TTravelActivityTicketTouristConfiguration
	quantity: number
	complementary: number
	currency: string
	calculated_price?: number
	per_quantity_given_price?: number
	given_price: number
	per_quantity_booked_price?: number
	booked_price: number
}

export type TTravelActiviytBooking = IPaymentable & {
	id: number
	trip_id: number
	start_date: string
	start_date_local?: string
	start_time_local?: string
	start_time_formatted?: string
	end_date: string
	end_date_local?: string
	end_time_local?: string
	end_time_formatted?: string
	slot?: string
	duration?: string
	duration_formatted?: string
	pick_up_location?: TTransportServiceLocationPoint
	drop_location?: TTransportServiceLocationPoint
	use_hotel_as_pickup?: string
	use_hotel_as_drop?: string
	activity: TTravelActivity
	ticket_type?: TTravelActivityTicketType
	title: string
	comments?: string
	ticket_tourist_configurations: Array<TTravelActivityBookingTicketTouristConfiguration>
	ticket_tourist_configurations_short_name?: string
	ticket_tourist_configurations_full_name?: string
	ticket_tourist_configurations_full_name_with_complementary?: string
	group_id?: number
	sort_order: number
	currency: string
	booked_price: number
	booked_price_money: TFormattedMoney
	itinerary?: {
		id: number
		name: string
		description: string
	}
	is_booked?: boolean
	// Same sa is_booked
	booked?: boolean
	supplier?: ISupplier
	supplier_contact?: TSupplierContact
	remarks?: string
	confirmation_details?: string
	confirmed_at?: string
	confirmed_by?: IUser
	created_at: string
	created_by?: IUser
	updated_at?: string
	updated_by?: IUser
	trip?: ITrip
	dropped_at?: string
	can_modify?: boolean
	tourist?: TTourist
	tourists?: Array<TTourist>
	members?: TTouristMember[]
	voucher?: TActivityVoucher
}

export type TTravelActivityMember = {
	member: TTourist | TTouristGroup
	member_id: number
	member_type: "tourists" | "tourist_groups"
}

export type TUploadMethods = "Attach File" | "Upload QR"
export const uploadMethods = ["Attach File", "Upload QR"]

export type TActivityVoucher = {
	id?: number
	booking_id?: number
	timezone_offset: number
	upload_method: TUploadMethods
	show_prices?: 1 | 0
	remove_branding?: 1 | 0
	file_url?: string
	files?: { url?: string; upload?: File }[]
	notes?: string
	voucher_activities?: {
		title?: string
		valid_till?: Date | undefined
		remarks?: string
		tickets: {
			ticket_number: string
			no_of_pax: number
			generated_from_qr: 1 | 0
			remarks?: string
			tourists?: {
				id?: number
				tourist?: TTourist
				ticket_number: string
			}[]
		}[]
	}[]
	sent_at?: string
	sent_by?: IUser
	status?: TActivityVoucherStatus
}
export type TActivityVoucherStatus =
	| "pending"
	| "processing"
	| "completed"
	| "failed"

export type TRegenrateActivityVoucher = {
	booking_id?: number
	file_url: string
	files?: string[]
	id: number
	upload_method: TUploadMethods
	is_generating?: boolean
	show_prices?: 1 | 0
	remove_branding?: 1 | 0
	notes?: string
	sent_at?: string
	sent_by?: IUser
	status: TActivityVoucherStatus
	voucher_activities?: {
		title?: string
		valid_till?: Date | undefined
		remarks?: string
		tickets: {
			ticket_number: string
			generated_from_qr: 1 | 0
			no_of_pax: number
			remarks?: string
			tourists?: (TTourist & { ticket_number: string })[]
		}[]
	}[]
}

export const QR_ERRORS = {
	DETECTION_FAILED: "Could not detect QR code in this image.",
} as const
